import { Toaster } from '@bia-auction/ui';
import { t } from '@bia-auction/shared-i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './lib/auth';
import { BRAND } from './lib/config';
import { initLang } from './lib/i18n';
import { router } from './router';
import './index.css';

// Restore the persisted language before first paint (default tr), then set the document title
// from configured branding (ADR 0015) — the static index.html title is a placeholder.
initLang();
document.title = t('bidder.appTitle', { brand: BRAND });

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
